import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { useEffect, useRef, useState, useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery'
import { Grid, Stack, Typography } from '@mui/material';
import config from "../../config.json"

const waldVitalitaetLegend = require("../../ressources/legends/legendWaldVitalitaet.png")
const waldartenLegend = require("../../ressources/legends/legendWaldarten.png")
const baumhoehe = require("../../ressources/legends/baumhoehe.png")
const schadflaechen = require("../../ressources/legends/schadflaechen.png")
const biomasse = require("../../ressources/legends/legendBiomassAGB.png")
const kohlenstoffLegend = require("../../ressources/legends/legendKohlenstoff.png")

interface LegendSimpleProps {
    layerSelection: any
}

export default function LegendSimple({ layerSelection }: LegendSimpleProps) {
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));

    // let legendImage;



    let legendImages: { [key: string]: string } = {};

    legendImages = {
        "WALDARTEN": waldartenLegend,
        "BAUMHOEHE": baumhoehe,
        "BIOMASSE": biomasse,
        "KOHLENSTOFFGEHALT": kohlenstoffLegend,
        "SCHADFLAECHEN": schadflaechen
    }

    interface LegendInfo {
        rescaleMin: string;
        rescaleMax: string;
        unit: string,
        image: any;
    }

    let legendInfo: LegendInfo = {
        rescaleMax: "",
        rescaleMin: "",
        unit: "",
        image: null
    }


    function setLegendInfo(layerSelection: any) {
        // Get rescale factor dynamically from drone/satelliteRasterLayerInfo

        switch (layerSelection.layer2) {

            case "WALDARTEN":
                legendInfo.image = legendImages["WALDARTEN"]
                legendInfo.unit = ""
                legendInfo.rescaleMin = "Laubwald"
                legendInfo.rescaleMax = "Nadelwald"
                break;
            case "BAUMHOEHE":
                legendInfo.image = legendImages["BAUMHOEHE"]
                legendInfo.unit = ""
                legendInfo.rescaleMin = "< 10 m"
                legendInfo.rescaleMax = "> 35 m"
                break;
            case "BIOMASSE":
                legendInfo.image = legendImages["BIOMASSE"]
                legendInfo.unit = ""
                legendInfo.rescaleMin = "< 10 t/ha"
                legendInfo.rescaleMax = "> 180 t/ha"
                break;
            case "KOHLENSTOFFGEHALT":
                legendInfo.image = legendImages["KOHLENSTOFFGEHALT"]
                legendInfo.unit = ""
                legendInfo.rescaleMin = "0 t/ha"
                legendInfo.rescaleMax = "> 80 t/ha"
                break;
            case "SCHADFLAECHEN":
                legendInfo.image = legendImages["SCHADFLAECHEN"]
                legendInfo.unit = ""
                legendInfo.rescaleMin = "Schadflächen"
                break;
        }



    }

    setLegendInfo(layerSelection)


    const legendContent1 = (
        <>
            <Stack alignItems="center" >
                <Box
                    component="img"
                    sx={{
                        // m: 1,
                        // width: "70vw",
                        p: 1,
                        width: "100%",
                    }}
                    src={legendInfo.image}
                />
            </Stack>
        </>
    )





    const legendContent2 = (
        <>
            <Stack alignItems="center" >
                <Box
                    component="img"
                    sx={{
                        // m: 1,
                        // width: "70vw",
                        p: 1,
                        width: "80%",
                    }}
                    src={legendInfo.image}
                />
            </Stack>
            <Paper elevation={0} >
                {layerSelection.layer2 === "SCHADFLAECHEN" ?
                    <Grid container direction="row" justifyContent="center" paddingLeft={1} paddingRight={1} >
                        <Grid item>
                            <Typography variant="body2" color="text.secondary" mb={1}>
                                {legendInfo.rescaleMin} {legendInfo.unit}
                            </Typography>
                        </Grid>

                    </Grid>
                    :
                    <Grid container direction="row" justifyContent="space-between" paddingLeft={1} paddingRight={1} >
                        <Grid item>
                            <Typography variant="body2" color="text.secondary" mb={1}>
                                {legendInfo.rescaleMin} {legendInfo.unit}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="body2" color="text.secondary" mb={1}>
                                {legendInfo.rescaleMax} {legendInfo.unit}
                            </Typography>
                        </Grid>
                    </Grid>
                }
            </Paper>
        </>

    )

    return (
        <>
            {!mobile && 
            legendInfo.image && 
                    <LegendDesktop
                        layerSelection={layerSelection}>
                        {legendContent2}
                    </LegendDesktop>
            }

        </>


    )

}

function LegendDesktop(props: any) {
    const widthBleeding = 300;
    const marginLeft = config.sizing.drawerWidthDesktop/2  + (-widthBleeding / 2); 

    return (
        <Box
            sx={{
                position: 'absolute',
                display: 'flex',
                zIndex: 1000,
                m: 2,
                left: "50%",
                width: `${widthBleeding}px`,
                ml: `${marginLeft}px`,

            }}
        >
            <Paper elevation={3} >
                {props.children}
            </Paper>
        </Box >
    );
}

function LegendMobile(props: any) {
    return (
        <Box
            sx={{
                position: 'relative',
                zIndex: 1000,
                // bottom: 100,
            }}
        >
            <Paper elevation={3} square={true}>
                {props.children}
            </Paper>
        </Box >
    );
}